import React, {useState} from 'react';
import './style.css';
import {useNavigate, useParams} from 'react-router-dom';
import {
  formatTimeZoneString,
  getLocalStorageUserInfo,
} from '../../../Util/commonUtility';
import {ClockTimeSVG2} from '../../../Assets/svgComponents/ClockTimeSVG';
import useLocalization from '../../../Localization';

const EventCard = ({
  sponsors,
  exhibitors,
  eventName,
  isRegistrationOpen,
  location,
  registerText,
  price,
  speakers,
  eventTypeName,
  eventChapter,
  EventId,
  organizers,
  dateObject,
  details,
  showRegisterNow,
  isWebcastAvailable,
  status,
  registrationClosesText,
  otherSponsorshipSlotsOpen,
  vendorShowSlotsOpen,
}) => {
  const Navigate = useNavigate();
  const {ApplicationString} = useLocalization();
  const otherSlotsOpen =
    otherSponsorshipSlotsOpen === undefined ? false : otherSponsorshipSlotsOpen;
  const vendorSlotsOpen =
    vendorShowSlotsOpen === undefined ? false : vendorShowSlotsOpen;
  const OnRegisterHandler = () => {
    const userInfo = getLocalStorageUserInfo();
    localStorage.setItem('isGuestUserRegister', EventId);
    userInfo ? Navigate(`/addAttendees/${EventId}`) : Navigate(`/login`);
  };

  return (
    <React.Fragment>
      <div className='event-main-container'>
        <div className='event-sub-container'>
          <div className='event-top-line'>
            <span>
              <div className='event-title-row'>
                {eventChapter && (
                  <div className='event-details-chapter-badge'>
                    {eventChapter}
                  </div>
                )}

                <div className='type'>{eventTypeName}</div>

                {isWebcastAvailable && (
                  <div className='type'>
                    {ApplicationString['eventCard.webcastForNonLocalAttendees']}
                  </div>
                )}
              </div>

              <div className='date'>
                <p>
                  {dateObject?.event_start_date === dateObject?.event_end_date
                    ? dateObject?.event_start_date
                    : `${dateObject?.event_start_date} to ${dateObject?.event_end_date}`}
                  {' |'}
                </p>
                <label>
                  <ClockTimeSVG2 />
                  {dateObject?.event_start_time} - {dateObject?.event_end_time}{' '}
                  {formatTimeZoneString(dateObject?.time_zone)}
                </label>
              </div>
            </span>
            {showRegisterNow && (
              <div
                id={`eventDetails-registerButton_${EventId}`}
                className='button'>
                <button onClick={OnRegisterHandler}>{registerText}</button>
              </div>
            )}
            {Number(status) === 2 && (
              <div className='button'>
                <span className='registration-closed-badge'>
                  {ApplicationString['eventCard.registrationClosed']}
                </span>
              </div>
            )}
          </div>
          <div className='event-name-text'>
            <p>{eventName}</p>
          </div>
          <div className='event-details-container-card'>
            {details ? (
              <div className='details-li'>
                <p>{ApplicationString['eventCard.details']}:</p>{' '}
                <label>{details}</label>
              </div>
            ) : null}
            {speakers ? (
              <div className='details-li'>
                <p>{ApplicationString['eventCard.speakers']}:</p>{' '}
                <label>{speakers}</label>
              </div>
            ) : null}
            <div className='details-li'>
              <p>{ApplicationString['eventCard.organizers']}:</p>{' '}
              <label>{organizers}</label>
            </div>
            <div className='details-li'>
              <p>{ApplicationString['eventCard.registrationClosesOn']}:</p>
              <label className='mb-date-text'>
                {registrationClosesText
                  ? registrationClosesText
                  : dateObject?.reg_end_date && dateObject?.reg_end_time
                  ? `${dateObject.reg_end_date} - ${
                      dateObject.reg_end_time
                    } ${formatTimeZoneString(dateObject?.time_zone)}`
                  : ''}
              </label>
            </div>
            <div className='mb-detail-list'>
              {price && (
                <div className='details-li'>
                  <p>{ApplicationString['eventCard.registrationFee']}:</p>
                  <label className='mb-price-text'>{price}</label>
                </div>
              )}
            </div>
            <div className='details-li location-li-extend'>
              <p>{ApplicationString['eventCard.location']}:</p>{' '}
              <label className='mb-location-text'>{location}</label>
            </div>
            {(sponsors?.length > 0 || otherSlotsOpen) && (
              <div className='details-li'>
                <p>{ApplicationString['eventCard.sponsors']}:</p>
                <label>
                  {sponsors?.length > 0
                    ? `${sponsors.join(', ')}${
                        otherSlotsOpen
                          ? `; ${ApplicationString['eventCard.otherSponsorshipOpportunitiesOpen']}`
                          : ''
                      }`
                    : ApplicationString[
                        'eventCard.sponsorshipOpportunitiesOpen'
                      ]}
                </label>
              </div>
            )}

            {(exhibitors?.length > 0 || vendorSlotsOpen) && (
              <div className='details-li'>
                <p>{ApplicationString['eventCard.exhibitors']}:</p>
                <label>
                  {exhibitors?.length > 0
                    ? exhibitors.join(', ')
                    : ApplicationString[
                        'eventCard.vendorShowExhibitorOpportunitiesOpen'
                      ]}
                </label>
              </div>
            )}
          </div>
          {showRegisterNow && (
            <div className='mb-button'>
              <button onClick={OnRegisterHandler}>{registerText}</button>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default EventCard;
